import { EndPointService } from 'src/services/api-handlers/axios';

const ROUTE = 'users';

export interface UserStats {
    total: number;
    active: number;
    inactive: number;
}

const list = (params: any) => EndPointService.get(`/${ROUTE}`, params);
const getStats = () => EndPointService.get<UserStats>(`/${ROUTE}/stats`);
const get = (userId: string) => EndPointService.get(`/${ROUTE}/${userId}`);
const update = (userId: string, data: any) => EndPointService.patch(`/${ROUTE}/${userId}`, data);
const create = (data: any) => EndPointService.post(`/${ROUTE}/`, data);
const remove = (userId: string) => EndPointService.delete(`/${ROUTE}/${userId}`);

export default {
    list,
    getStats,
    get,
    update,
    create,
    remove,
};
